module.exports = __webpack_public_path__ + "static/media/output.inactive.b931d76f.svg";